import { routerReducer } from '@ngrx/router-store';
import { Action, ActionReducerMap, createReducer, on } from '@ngrx/store';
import { setAppId } from './app.actions';

import { SelfServeAppState } from './app.state.model';
import { authStateReducer } from '@rci/self-serve-fido/state/auth/auth.reducers';
import { userInformationReducer } from './user-information';

export const globalReducers: ActionReducerMap<SelfServeAppState> = {
  appId: appIdReducer,
  authState: authStateReducer,
  router: routerReducer,
  userInformation: userInformationReducer,
};

const createAppIdReducer = createReducer(
  '',
  on(setAppId, (_state, { appId }) => appId),
);

// eslint-disable-next-line
export function appIdReducer(state: string, action: Action) {
  return createAppIdReducer(state, action);
}
